import { useEffect } from "react";

import { useEscapeKey } from "./useEscapeKey";

// Closes a dropdown on Escape or on a click outside both the anchor and the menu.
export const useDropdownDismiss = (
  anchorRef: React.RefObject<HTMLElement | null>,
  menuRef: React.RefObject<HTMLElement | null>,
  isOpen: boolean,
  close: () => void,
) => {
  useEscapeKey(close, isOpen);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handlePointer = (event: MouseEvent) => {
      const target = event.target as Node;
      const insideAnchor = anchorRef.current?.contains(target) ?? false;
      const insideMenu = menuRef.current?.contains(target) ?? false;
      if (!insideAnchor && !insideMenu) {
        close();
      }
    };

    document.addEventListener("mousedown", handlePointer);

    return () => {
      document.removeEventListener("mousedown", handlePointer);
    };
  }, [anchorRef, menuRef, isOpen, close]);
};
